import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  styled,
} from "@mui/material";
import { Refresh as RefreshIcon } from "@mui/icons-material";
import { useAppSelector } from "redux/hooks";
import { useTranslation } from "react-i18next";
const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
  },
}));

interface BuildModalProps {}

const BuildModal: React.FC<BuildModalProps> = () => {
  const { t } = useTranslation();

  const { newBuildNotification } = useAppSelector(
    (state) => state.notificationHistory
  );
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <StyledDialog
      open={newBuildNotification}
      aria-labelledby="build-modal-title"
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return;
        }
      }}
    >
      <DialogTitle id="build-modal-title">
        <Typography
          variant="h6"
          component="div"
          fontWeight="bold"
          align="center"
        >
          {t("new_version_available", "New Version Available")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ py: 2 }}>
          <Typography variant="body1" color="text.secondary" align="center">
            {t(
              "new_version_available_description",
              "We apologize for any inconvenience, Please refresh your browser to ensure you have the latest features and improvements."
            )}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleRefresh}
          startIcon={<RefreshIcon />}
          fullWidth
          size="large"
        >
          {t("refresh_browser", "Refresh Browser")}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default BuildModal;
